import { useMapEvent } from 'react-leaflet';

/**
 * マップのイベントハンドリング用コンポーネント
 */
const MyComponent = ({ changeZoom, onMoveEnd, onMapClick }) => {
  const map = useMapEvent('zoomend', () => {
    if (changeZoom === '') return;
    if (map.getZoom() < 3) {
      map.setZoom(3);
      changeZoom(3);
    } else {
      changeZoom(map.getZoom());
    }
  });
  const center = useMapEvent('moveend', () => {
    if (onMoveEnd === '') return;
    onMoveEnd(center.getCenter());
  });
  useMapEvent('click', (e) => {
    if (onMapClick === '') return;
    onMapClick(e.latlng);
  });
  return null;
};
export default MyComponent;
